const map = {
	"./MarketArrow": 12490,
	"./MarketArrow.js": 12490,
	"./advante-team.webp": 96702,
	"./ai-solutions/ai-custom-solution-1.webp": 33805,
	"./ai-solutions/ai-custom-solution-2.webp": 60096,
	"./ai-solutions/ai-custom-solution-3.webp": 43139,
	"./ai-solutions/ai-custom-solution-4.webp": 50078,
	"./ai-solutions/ai-custom-solution-5.webp": 61113,
	"./ai-solutions/current-platform-1.webp": 61064,
	"./ai-solutions/current-platform-13.webp": 381,
	"./ai-solutions/current-platform-14.webp": 39788,
	"./ai-solutions/current-platform-2.webp": 96021,
	"./ai-solutions/current-platform-3.webp": 79018,
	"./ai-solutions/current-platform-4.webp": 32199,
	"./ai-solutions/current-platform-5.webp": 68164,
	"./ai-solutions/current-platform-6.webp": 86337,
	"./ai-solutions/current-platform-7.webp": 16582,
	"./ai-solutions/current-platform-8.webp": 24739,
	"./all-nation/all-nation-app.webp": 24144,
	"./all-nation/all-nation-gradient.webp": 72829,
	"./all-nation/all-nation-phone.webp": 3843,
	"./all-nation/app-slides.webp": 7187,
	"./all-nation/city-img.webp": 20798,
	"./all-nation/code-bg.webp": 3170,
	"./all-nation/features-img.webp": 35646,
	"./all-nation/impact-bg.webp": 59815,
	"./articles/GitHub-Copilot.jpg": 86117,
	"./articles/HEX_corto.avif": 51198,
	"./articles/article-25-thumbnail.webp": 12300,
	"./articles/article-25.webp": 55569,
	"./articles/article-26-thumbnail.webp": 49053,
	"./articles/article-26.webp": 96308,
	"./articles/article-27-thumbnail.webp": 40714,
	"./articles/article-27.webp": 19319,
	"./articles/article-28-thumbnail.webp": 58691,
	"./articles/article-28.webp": 94674,
	"./articles/article-29-thumbnail.webp": 73736,
	"./articles/article-29.webp": 46013,
	"./articles/article-30-thumbnail.webp": 53570,
	"./articles/article-30.webp": 27055,
	"./articles/article-header.webp": 31077,
	"./articles/articles-header.jpg": 95450,
	"./articles/articles-header.webp": 18436,
	"./articles/average-conversion-ratio.avif": 76219,
	"./articles/average-grades-increase.jpg": 98872,
	"./articles/aws.avif": 96928,
	"./articles/clinical-data.avif": 6225,
	"./articles/comparative.avif": 28228,
	"./articles/cough.avif": 82631,
	"./articles/coversion-rate.avif": 88616,
	"./articles/open-thread.avif": 76914,
	"./articles/productivity-increases-ai.jpg": 73124,
	"./articles/time-taken-decreases.jpg": 80418,
	"./articles/tiny-chef.avif": 26696,
	"./articles/transcript.avif": 83941,
	"./behind-advante.webp": 14983,
	"./bgr-multicolor-flat.webp": 14479,
	"./bgr-multicolor-large.webp": 51975,
	"./bgr-multicolor-small.webp": 74095,
	"./bgr-software-service.webp": 56806,
	"./bridgewater/bridge-landing2.webp": 11517,
	"./bridgewater/challenge-app.webp": 23449,
	"./bridgewater/development-bg.webp": 13605,
	"./bridgewater/features.webp": 15869,
	"./bridgewater/header-img.webp": 33465,
	"./bridgewater/phone-app1.webp": 25331,
	"./bridgewater/phone-app2.webp": 91058,
	"./caseStudies/ANS-1.webp": 29677,
	"./caseStudies/ANS-2.webp": 51360,
	"./caseStudies/ANS-3.webp": 5059,
	"./caseStudies/Aflac-1.webp": 88280,
	"./caseStudies/Aflac-2.webp": 72677,
	"./caseStudies/Aflac-3.webp": 51578,
	"./caseStudies/Ameritrade-1.webp": 49517,
	"./caseStudies/Ameritrade-2.webp": 6432,
	"./caseStudies/Ameritrade-3.webp": 10275,
	"./caseStudies/Bajibot-1.webp": 62232,
	"./caseStudies/Bajibot-2.webp": 1157,
	"./caseStudies/Bajibot-3.webp": 87130,
	"./caseStudies/BodyArmor-1.webp": 17830,
	"./caseStudies/BodyArmor-2.webp": 65735,
	"./caseStudies/BodyArmor-3.webp": 12036,
	"./caseStudies/Bridgewater-1.webp": 17245,
	"./caseStudies/Bridgewater-2.webp": 74416,
	"./caseStudies/Bridgewater-3.webp": 179,
	"./caseStudies/BuffaloTrace-1.webp": 71477,
	"./caseStudies/BuffaloTrace-2.webp": 55368,
	"./caseStudies/BuffaloTrace-3.webp": 69099,
	"./caseStudies/Chicago-1.webp": 23389,
	"./caseStudies/Chicago-2.webp": 14736,
	"./caseStudies/ComputerAES.webp": 73623,
	"./caseStudies/ComputerANS.webp": 54536,
	"./caseStudies/ComputerAflac.webp": 7129,
	"./caseStudies/ComputerBajibot.webp": 76873,
	"./caseStudies/ComputerBernzomatic.webp": 68184,
	"./caseStudies/ComputerBodyArmor.webp": 9135,
	"./caseStudies/ComputerBridgewater.webp": 15108,
	"./caseStudies/ComputerBuffaloTrace.webp": 36778,
	"./caseStudies/ComputerChicago.webp": 59764,
	"./caseStudies/ComputerCoronet.webp": 85204,
	"./caseStudies/ComputerDavidOrtiz.webp": 76802,
	"./caseStudies/ComputerDigitalLife.webp": 38586,
	"./caseStudies/ComputerEaglesFC.webp": 21446,
	"./caseStudies/ComputerFriendsoftheLake.webp": 25048,
	"./caseStudies/ComputerHulu.webp": 62792,
	"./caseStudies/ComputerJudigoLegal.webp": 27225,
	"./caseStudies/ComputerManeeAddicts.webp": 88824,
	"./caseStudies/ComputerNutiva.webp": 38199,
	"./caseStudies/ComputerPlanutGoods.webp": 71596,
	"./caseStudies/ComputerRowdy.webp": 23935,
	"./caseStudies/ComputerSPA.webp": 28702,
	"./caseStudies/ComputerSeagrams.webp": 33857,
	"./caseStudies/ComputerSixPlusOne.webp": 86760,
	"./caseStudies/ComputerSprout.webp": 86813,
	"./caseStudies/ComputerStafWizard.webp": 94647,
	"./caseStudies/ComputerSynchrony.webp": 47739,
	"./caseStudies/ComputerimposibleEscape.webp": 50975,
	"./caseStudies/DigitalLife-1.webp": 59787,
	"./caseStudies/DigitalLife-2.webp": 23722,
	"./caseStudies/DigitalLife-3.webp": 74901,
	"./caseStudies/EagleFC-1.webp": 17770,
	"./caseStudies/EagleFC-2.webp": 70187,
	"./caseStudies/EagleFC-3.webp": 62248,
	"./caseStudies/Friends-1.webp": 65104,
	"./caseStudies/Friends-2.webp": 7933,
	"./caseStudies/Friends-3.webp": 83218,
	"./caseStudies/Hulu-1.webp": 85395,
	"./caseStudies/Hulu-2.webp": 40050,
	"./caseStudies/Hulu-3.webp": 99965,
	"./caseStudies/ImpossibleEscape-1.webp": 34873,
	"./caseStudies/ImpossibleEscape-2.webp": 85948,
	"./caseStudies/ImpossibleEscape-3.webp": 87487,
	"./caseStudies/ManeAddicts-1.webp": 64746,
	"./caseStudies/ManeAddicts-2.webp": 66635,
	"./caseStudies/ManeAddicts-3.webp": 69256,
	"./caseStudies/MySpa-1.webp": 45985,
	"./caseStudies/MySpa-2.webp": 25348,
	"./caseStudies/MySpa-3.webp": 79047,
	"./caseStudies/Nutiva-1.webp": 23088,
	"./caseStudies/Nutiva-2.webp": 989,
	"./caseStudies/Nutiva-3.webp": 14578,
	"./caseStudies/PhoneiBird.webp": 63237,
	"./caseStudies/PlanutGood-1.webp": 59880,
	"./caseStudies/PlanutGood-2.webp": 82933,
	"./caseStudies/PlanutGood-3.webp": 15402,
	"./caseStudies/SixPlusOne-1.webp": 96143,
	"./caseStudies/SixPlusOne-2.webp": 42798,
	"./caseStudies/SixPlusOne-3.webp": 12521,
	"./caseStudies/StaffWizard-1.webp": 99708,
	"./caseStudies/StaffWizard-2.webp": 64985,
	"./caseStudies/StaffWizard-3.webp": 4094,
	"./caseStudies/Synchrony-1.webp": 47878,
	"./caseStudies/Synchrony-2.webp": 95783,
	"./caseStudies/Synchrony-3.webp": 42084,
	"./caseStudies/aes-1.webp": 66074,
	"./caseStudies/aes-2.webp": 26523,
	"./caseStudies/aes-3.webp": 41176,
	"./caseStudies/bernzomatic-1.webp": 43673,
	"./caseStudies/bernzomatic-2.webp": 84284,
	"./caseStudies/coronet-1.webp": 99721,
	"./caseStudies/coronet-2.webp": 5356,
	"./caseStudies/coronet-3.webp": 62447,
	"./caseStudies/david-1.webp": 75247,
	"./caseStudies/david-2.webp": 15950,
	"./caseStudies/david-3.webp": 55049,
	"./caseStudies/ibird-1.webp": 14293,
	"./caseStudies/ibird-2.webp": 21864,
	"./caseStudies/ibird-3.webp": 61771,
	"./caseStudies/judigo-1.webp": 57935,
	"./caseStudies/judigo-2.webp": 81294,
	"./caseStudies/judigo-3.webp": 77321,
	"./caseStudies/peachy-1.webp": 7007,
	"./caseStudies/peachy-2.webp": 18366,
	"./caseStudies/phoneAmeritrade.webp": 55697,
	"./caseStudies/phonePeachy.webp": 43143,
	"./caseStudies/rowdy-1.webp": 90942,
	"./caseStudies/rowdy-2.webp": 2879,
	"./caseStudies/rowdy-3.webp": 58588,
	"./caseStudies/seagrams-1.webp": 87366,
	"./caseStudies/seagrams-2.webp": 77799,
	"./caseStudies/seagrams-3.webp": 15204,
	"./caseStudies/sprout-1.webp": 24130,
	"./caseStudies/sprout-2.webp": 31555,
	"./caseStudies/sprout-3.webp": 44064,
	"./cases/background-case-design.webp": 2009,
	"./cases/background-case-e-commerce.webp": 27058,
	"./cases/case-01.webp": 27331,
	"./cases/case-02.webp": 19906,
	"./cases/case-03.webp": 82925,
	"./cases/case-04.webp": 3708,
	"./cases/case-05.webp": 5247,
	"./cases/case-06.webp": 8094,
	"./cases/case-07.webp": 68985,
	"./cases/case-08.webp": 80008,
	"./cases/case-09.webp": 14251,
	"./cases/case-13.webp": 54832,
	"./close.svg": 55871,
	"./collaborations-group-1.png": 13185,
	"./collaborations-group-2.png": 64202,
	"./credit-card-base.webp": 8771,
	"./credit-card-effect.webp": 98419,
	"./development-setup.webp": 64744,
	"./dots-bgr.png": 13573,
	"./double-underline.svg": 79045,
	"./e-commerce/bgr-e-commerce.webp": 85032,
	"./events/event-25.webp": 32409,
	"./events/event-26.webp": 73020,
	"./events/event-27.webp": 79615,
	"./events/event-28.webp": 93450,
	"./events/event-29.webp": 55317,
	"./events/event-30.webp": 34391,
	"./events/event-31.webp": 23380,
	"./events/event-32.webp": 90097,
	"./events/event-33.webp": 73718,
	"./events/event-34.webp": 25563,
	"./events/event-35.webp": 87192,
	"./events/event-36.webp": 67365,
	"./events/event-37.webp": 3194,
	"./events/event-38.webp": 43247,
	"./events/event-39.webp": 68364,
	"./events/event-40.webp": 24104,
	"./events/event-41.webp": 58347,
	"./events/event-42.webp": 42058,
	"./graphic-design-technologies/ico-service-design-art.webp": 51912,
	"./graphic-design-technologies/ico-service-design-branding.webp": 36940,
	"./graphic-design-technologies/ico-service-design-design.webp": 52869,
	"./graphic-design-technologies/ico-service-design-wireframing.webp": 17480,
	"./graphic-design-technologies/logo-adobe-ai.webp": 98642,
	"./graphic-design-technologies/logo-adobe-ps.webp": 40949,
	"./graphic-design-technologies/logo-balsamiq-box.webp": 82490,
	"./graphic-design-technologies/logo-balsamiq.webp": 97778,
	"./graphic-design-technologies/logo-blender.webp": 85106,
	"./graphic-design-technologies/logo-canva.webp": 57345,
	"./graphic-design-technologies/logo-coreldraw.webp": 31385,
	"./graphic-design-technologies/logo-eraserio-box.webp": 65006,
	"./graphic-design-technologies/logo-excalidraw-box.webp": 87586,
	"./graphic-design-technologies/logo-excalidraw.webp": 85834,
	"./graphic-design-technologies/logo-figma-box.webp": 38370,
	"./graphic-design-technologies/logo-figma.webp": 55274,
	"./graphic-design-technologies/logo-invision.webp": 96977,
	"./graphic-design-technologies/logo-procreate.webp": 62105,
	"./guy-vr-interactive.webp": 91220,
	"./ia-robohands-header.webp": 60112,
	"./ico-brainstorm.webp": 39810,
	"./ico-collect.webp": 95867,
	"./ico-elements.webp": 91530,
	"./ico-launch.webp": 17448,
	"./ico-research.webp": 21890,
	"./ico-testing.webp": 39929,
	"./ico-uxuidesign.webp": 24910,
	"./ico-wireframing.webp": 2788,
	"./icons/digital-payment.webp": 11479,
	"./icons/e-commerce-software.webp": 7849,
	"./icons/finance-payment.webp": 89653,
	"./icons/finance-software.webp": 21872,
	"./icons/healthcare-payment.webp": 86888,
	"./icons/healthcare-software.webp": 60619,
	"./icons/hhrr-payment.webp": 13571,
	"./icons/ico-bag.png": 20814,
	"./icons/ico-hammer.png": 28892,
	"./icons/ico-heart.png": 19508,
	"./icons/ico-puzzle.png": 98158,
	"./icons/ico-statistics.png": 38111,
	"./icons/ico-store.png": 87875,
	"./icons/ico-stroke-architecture.png": 68928,
	"./icons/ico-stroke-cases.png": 94402,
	"./icons/ico-stroke-cube.png": 24842,
	"./icons/ico-stroke-flow.png": 21341,
	"./icons/ico-stroke-microservices.png": 18601,
	"./icons/ico-stroke-trees.png": 20434,
	"./icons/law-payment.webp": 47135,
	"./icons/legal-issues-software.webp": 24434,
	"./icons/marketplaces-software.webp": 59390,
	"./icons/startups-payment.webp": 65845,
	"./industry/digital-payment.webp": 28181,
	"./industry/e-commerce-software.webp": 92779,
	"./industry/finance-payment.webp": 37255,
	"./industry/finance-software.webp": 68422,
	"./industry/healthcare-payment.webp": 14502,
	"./industry/healthcare-software.webp": 18413,
	"./industry/hhrr-payment.webp": 3873,
	"./industry/ico-bag.png": 38246,
	"./industry/ico-hammer.png": 74676,
	"./industry/ico-heart.png": 14748,
	"./industry/ico-puzzle.png": 58246,
	"./industry/ico-statistics.png": 40327,
	"./industry/ico-store.png": 38091,
	"./industry/law-payment.webp": 96677,
	"./industry/legal-issues-software.webp": 69852,
	"./industry/marketplaces-software.webp": 82880,
	"./industry/startups-payment.webp": 76327,
	"./judigo-legal/access.webp": 23574,
	"./judigo-legal/css.webp": 23455,
	"./judigo-legal/expansion.webp": 12641,
	"./judigo-legal/grad1.webp": 13883,
	"./judigo-legal/grad2.webp": 69786,
	"./judigo-legal/html.webp": 5425,
	"./judigo-legal/java.webp": 65840,
	"./judigo-legal/js.webp": 26567,
	"./judigo-legal/js2.webp": 53495,
	"./judigo-legal/judigo-phone.webp": 54265,
	"./judigo-legal/lines.webp": 92979,
	"./judigo-legal/php.webp": 83960,
	"./judigo-legal/technical.webp": 65475,
	"./judigo-legal/time-sensitive.webp": 12780,
	"./judigo-legal/title.webp": 40466,
	"./key-symbol.svg": 46175,
	"./logo-clients/aflac.webp": 60747,
	"./logo-clients/bajibot.webp": 80659,
	"./logo-clients/bernzomatic.webp": 97786,
	"./logo-clients/bodyarmor.webp": 11845,
	"./logo-clients/bridgewater.webp": 15482,
	"./logo-clients/buffalotrace.webp": 88744,
	"./logo-clients/coronet.webp": 10290,
	"./logo-clients/crackerbarrel.webp": 37183,
	"./logo-clients/davidortiz.webp": 35896,
	"./logo-clients/fotl.webp": 73129,
	"./logo-clients/hulu.webp": 92454,
	"./logo-clients/maneaddicts.webp": 63261,
	"./logo-clients/myspalive.webp": 15180,
	"./logo-clients/nbc.webp": 16199,
	"./logo-clients/nutiva.webp": 65925,
	"./logo-clients/peachy.webp": 99142,
	"./logo-clients/planut.webp": 88884,
	"./logo-clients/robertmarc.webp": 92067,
	"./logo-clients/rowdy.webp": 31413,
	"./logo-clients/sarais.webp": 44031,
	"./logo-clients/seagrams.webp": 37543,
	"./logo-clients/sixplusone.webp": 65054,
	"./logo-clients/staffwizard.webp": 96683,
	"./logo-clients/syfy.webp": 11927,
	"./logo-clients/synchrony.webp": 38965,
	"./logo-clients/twsj.webp": 82242,
	"./logo-tech/logo-calendly.webp": 68316,
	"./logo-tech/logo-highlevel.webp": 96296,
	"./logo-tech/logo-mailchimp.webp": 3252,
	"./logo-tech/logo-mailgun.webp": 31421,
	"./logo-tech/logo-maps.webp": 27785,
	"./logo-tech/logo-pipedrive.webp": 27262,
	"./logo-tech/logo-quickbooks.webp": 46437,
	"./logo-tech/logo-roposo.webp": 91438,
	"./logo-tech/logo-stripe.webp": 79411,
	"./logo-tech/logo-twilio.webp": 18926,
	"./logo-tech/logo-zoom.webp": 5165,
	"./logo-technologies/logo-css.webp": 13507,
	"./logo-technologies/logo-flutter.webp": 93934,
	"./logo-technologies/logo-html.webp": 15013,
	"./logo-technologies/logo-java.webp": 56948,
	"./logo-technologies/logo-js.webp": 10883,
	"./logo-technologies/logo-klaviyo.webp": 25443,
	"./logo-technologies/logo-kotlin.webp": 61645,
	"./logo-technologies/logo-mailchimp.webp": 95898,
	"./logo-technologies/logo-mailgun.webp": 82455,
	"./logo-technologies/logo-maps.webp": 39259,
	"./logo-technologies/logo-paypal.webp": 3699,
	"./logo-technologies/logo-php.webp": 14812,
	"./logo-technologies/logo-quickbooks.webp": 33527,
	"./logo-technologies/logo-react.webp": 47371,
	"./logo-technologies/logo-shopify.webp": 28918,
	"./logo-technologies/logo-stripe.webp": 77009,
	"./logo-technologies/logo-swift.webp": 23119,
	"./logo-technologies/logo-twilio.webp": 94644,
	"./logo-technologies/logo-woo.webp": 1047,
	"./logo-technologies/logo-zoom.webp": 12031,
	"./logo_advante.png": 67508,
	"./logo_advante.webp": 14178,
	"./market-analysis/arrow-step-1.svg": 72283,
	"./market-analysis/arrow-step-2.svg": 37896,
	"./market-analysis/arrow-step-3.svg": 3289,
	"./market-analysis/circle-sketch.svg": 29488,
	"./market-analysis/data-collection-img.webp": 35578,
	"./market-analysis/empower-item-1.webp": 40962,
	"./market-analysis/empower-item-2.webp": 41283,
	"./market-analysis/empower-item-3.webp": 71232,
	"./market-analysis/empower-item-4.webp": 9433,
	"./market-analysis/ico-bars.png": 53515,
	"./market-analysis/ico-bulb.png": 57160,
	"./market-analysis/ico-chip.png": 97379,
	"./market-analysis/ico-flask.png": 6656,
	"./market-analysis/ico-lens.png": 38713,
	"./market-analysis/ico-mountain.png": 49344,
	"./market-analysis/ico-people.png": 35192,
	"./market-analysis/ico-wallet.png": 58962,
	"./market-analysis/identification-opportunities.webp": 94623,
	"./market-analysis/implementation.webp": 72355,
	"./market-analysis/market-segmentation.webp": 13318,
	"./market-analysis/subline-red-sketch.svg": 36556,
	"./menu-advante.svg": 70424,
	"./motionode/ai-builder-pr.png": 82825,
	"./motionode/code-browser.png": 66508,
	"./motionode/database.png": 73463,
	"./motionode/delivery-steps.png": 65086,
	"./motionode/pipeline-flow.png": 57245,
	"./motionode/ticket-changes.png": 19476,
	"./noise.png": 81157,
	"./payment-cone.webp": 72881,
	"./payment-cube.webp": 31939,
	"./payment-donut.webp": 84890,
	"./picture-durango.webp": 42572,
	"./picture-newyork.webp": 74119,
	"./rowdy-energy/challenge-ellipse.webp": 95156,
	"./rowdy-energy/fruits.webp": 32473,
	"./rowdy-energy/get-rowdy.webp": 93748,
	"./rowdy-energy/purple-circle.webp": 95331,
	"./rowdy-energy/rowdy-features.webp": 69211,
	"./rowdy-energy/rowdy-landing.webp": 84055,
	"./rowdy-energy/rowdy-outcome.webp": 88904,
	"./rowdy-energy/rowdy-solution.webp": 45667,
	"./seagrams/bottle.webp": 94043,
	"./seagrams/development-wave.webp": 97110,
	"./seagrams/features1.webp": 81123,
	"./seagrams/features2.webp": 16226,
	"./seagrams/outcome-app.webp": 84051,
	"./seagrams/seagrams-landing.webp": 29760,
	"./seagrams/seagrams-wave.webp": 18120,
	"./seagrams/solution-wave.webp": 79274,
	"./software-layout-bottom.webp": 82553,
	"./software-layout.webp": 92319,
	"./solutions/ico-01-2.webp": 79502,
	"./solutions/ico-01.svg": 68727,
	"./solutions/ico-02-2.webp": 74599,
	"./solutions/ico-02.svg": 14276,
	"./solutions/ico-03-2.webp": 75112,
	"./solutions/ico-03.svg": 11525,
	"./solutions/ico-04-2.webp": 67649,
	"./solutions/ico-04.svg": 4346,
	"./solutions/ico-05-2.webp": 45266,
	"./solutions/ico-05.svg": 81867,
	"./solutions/ico-06-2.webp": 97579,
	"./solutions/ico-06.svg": 23800,
	"./solutions/ico-07-2.webp": 48428,
	"./solutions/ico-07.svg": 49161,
	"./solutions/ico-08-2.webp": 87349,
	"./solutions/ico-08.svg": 19374,
	"./solutions/ico-09-2.webp": 33846,
	"./solutions/ico-09.svg": 34015,
	"./solutions/ico-10-2.webp": 84884,
	"./solutions/ico-10.svg": 98609,
	"./solutions/ico-11-2.webp": 31059,
	"./solutions/ico-11.svg": 79008,
	"./solutions/ico-12-2.webp": 29914,
	"./solutions/ico-12.svg": 99763,
	"./solutions/ico-13-2.webp": 28073,
	"./solutions/ico-13.svg": 78242,
	"./solutions/ico-14-2.webp": 2160,
	"./solutions/ico-14.svg": 48461,
	"./solutions/ico-15-2.webp": 43119,
	"./solutions/ico-15.svg": 65868,
	"./solutions/ico-16-2.webp": 54806,
	"./solutions/ico-16.svg": 28543,
	"./solutions/ico-17-2.webp": 95573,
	"./solutions/ico-17.svg": 16462,
	"./solutions/ico-18-2.webp": 44204,
	"./solutions/ico-18.svg": 29897,
	"./solutions/ico-19-2.webp": 46827,
	"./solutions/ico-19.svg": 42008,
	"./solutions/ico-20-2.webp": 78155,
	"./solutions/ico-20.svg": 21880,
	"./solutions/ico-21.svg": 56745,
	"./solutions/ico-22.svg": 58010,
	"./solutions/ico-23.svg": 77067,
	"./solutions/ico-24.svg": 14916,
	"./solutions/ico-25.svg": 69637,
	"./solutions/ico-26.svg": 70502,
	"./solutions/ico-27.svg": 41687,
	"./solutions/ico-28.svg": 82560,
	"./solutions/ico-29.svg": 29009,
	"./solutions/ico-30.svg": 86427,
	"./solutions/ico-31.svg": 33962,
	"./solutions/ico-32.svg": 83257,
	"./solutions/ico-33.svg": 70888,
	"./solutions/ico-34.svg": 73287,
	"./solutions/ico-35.svg": 26422,
	"./solutions/ico-36.svg": 46709,
	"./solutions/ico-tips-1.svg": 27494,
	"./solutions/ico-tips-2.svg": 49925,
	"./solutions/image-01.webp": 60617,
	"./solutions/image-02.webp": 66348,
	"./solutions/image-03.webp": 41231,
	"./solutions/image-04.webp": 18578,
	"./solutions/image-05.webp": 43293,
	"./solutions/image-06.webp": 464,
	"./solutions/image-07.webp": 26227,
	"./solutions/image-08.webp": 88054,
	"./solutions/image-09.webp": 88081,
	"./solutions/image-10.webp": 85763,
	"./solutions/image-11.webp": 98272,
	"./solutions/image-12.webp": 41357,
	"./solutions/image-13.webp": 78338,
	"./solutions/image-14.webp": 63679,
	"./solutions/image-15.webp": 62140,
	"./solutions/image-16.webp": 27417,
	"./solutions/image-17.webp": 66526,
	"./solutions/image-18.webp": 72683,
	"./spa-live/design-bg.webp": 73733,
	"./spa-live/design-img.webp": 16465,
	"./spa-live/development-bg.webp": 51786,
	"./spa-live/development-img.webp": 75444,
	"./spa-live/evaluation-bg.webp": 98541,
	"./spa-live/evaluation-img.webp": 8489,
	"./spa-live/grad1.webp": 19912,
	"./spa-live/grad2.webp": 54869,
	"./spa-live/grad3.webp": 21514,
	"./spa-live/implementation-bg.webp": 33565,
	"./spa-live/implementation-img.webp": 99353,
	"./spa-live/phone-spa.webp": 17804,
	"./spa-live/planning-bg.webp": 43556,
	"./spa-live/planning-img.webp": 3278,
	"./spa-live/technologies.webp": 93111,
	"./staffwizard/approach.webp": 30733,
	"./staffwizard/gradient.webp": 7009,
	"./staffwizard/innovation.webp": 97934,
	"./staffwizard/line.webp": 36111,
	"./staffwizard/staff-solutions.webp": 81600,
	"./staffwizard/staffPanel.webp": 46525,
	"./svg/AdvanteLogo": 94400,
	"./svg/AdvanteLogo.jsx": 94400,
	"./svg/IcoArrowThin": 12435,
	"./svg/IcoArrowThin.jsx": 12435,
	"./svg/IcoBasketSmile": 15931,
	"./svg/IcoBasketSmile.jsx": 15931,
	"./svg/IcoCalendarDollar": 86953,
	"./svg/IcoCalendarDollar.jsx": 86953,
	"./svg/IcoCheckoutLocation": 43552,
	"./svg/IcoCheckoutLocation.jsx": 43552,
	"./svg/IcoEcommerce": 90489,
	"./svg/IcoEcommerce.jsx": 90489,
	"./svg/IcoMobileBill": 19520,
	"./svg/IcoMobileBill.jsx": 19520,
	"./svg/IcoPlatformIntegrations": 48157,
	"./svg/IcoPlatformIntegrations.jsx": 48157,
	"./svg/IcoSocialFacebook": 52604,
	"./svg/IcoSocialFacebook.jsx": 52604,
	"./svg/IcoSocialInstagram": 44810,
	"./svg/IcoSocialInstagram.jsx": 44810,
	"./svg/IcoSocialLinkedin": 62390,
	"./svg/IcoSocialLinkedin.jsx": 62390,
	"./svg/IcoSocialTwitter": 10227,
	"./svg/IcoSocialTwitter.jsx": 10227,
	"./svg/IcoSoftwareDevelopment": 33887,
	"./svg/IcoSoftwareDevelopment.jsx": 33887,
	"./svg/bgr-bean.svg": 34168,
	"./svg/circle-sketch.svg": 23493,
	"./svg/design-A.svg": 36604,
	"./svg/ico-clock.svg": 37542,
	"./svg/ico-location.svg": 23913,
	"./svg/star-testimonial.svg": 58466,
	"./svg/union-grid-full.svg": 15316,
	"./tag-symbol.svg": 16444,
	"./team/alan.webp": 62505,
	"./team/alexis.webp": 69267,
	"./team/alma.webp": 83092,
	"./team/alonso.webp": 68681,
	"./team/antonio.webp": 54697,
	"./team/aric.webp": 87224,
	"./team/atzael.webp": 66510,
	"./team/brian.webp": 61881,
	"./team/carlos-fernando.webp": 41097,
	"./team/claudio.webp": 94422,
	"./team/cory.webp": 35344,
	"./team/eduardo.webp": 92947,
	"./team/emmanuel.webp": 82355,
	"./team/enrique.webp": 56038,
	"./team/felipe.webp": 27902,
	"./team/francisco-freyre.webp": 21361,
	"./team/hugo.webp": 24586,
	"./team/joel.webp": 19965,
	"./team/jorge-lara.webp": 73999,
	"./team/jorge-puente.webp": 24822,
	"./team/josue.webp": 10363,
	"./team/leo.webp": 95837,
	"./team/luis-fraire.webp": 54996,
	"./team/luis.webp": 89564,
	"./team/manuel.webp": 79649,
	"./team/marce.webp": 95281,
	"./team/mauro.webp": 79171,
	"./team/max.webp": 54551,
	"./team/meni.webp": 90220,
	"./team/omar.webp": 26712,
	"./team/paola.webp": 11398,
	"./team/ramon.webp": 43584,
	"./team/saul.webp": 62522,
	"./terminal-c.webp": 29895,
	"./terminal-html.webp": 42635,
	"./terminal-java.webp": 71674,
	"./union-grid.webp": 41381,
	"./x-bgr.png": 11361
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;